export default {
    breadcrumb: {
      home: 'Home',
      current: 'Teaching',
    },
    institutions: [
      // {
      //   id: 'hkustgz',
      //   title: 'The Hong Kong University of Science and Technology (Guangzhou)',
      //   subtitle: '(Lead instructor)',
      //   courses: [
      //     {
      //       id: 'cmaa5025',
      //       code: 'CMAA 5025',
      //       name: 'Computational Techniques for Sketch-based Creation',
      //       terms: ['Fall 2025', 'Fall 2024', 'Fall 2023', 'Spring 2023'],
      //     },
      //     {
      //       id: 'cmaa5014',
      //       code: 'CMAA 5014',
      //       name: 'Experimental 3D Rendering and Motion',
      //       note: '(Co-taught)',
      //       terms: ['Fall 2023'],
      //     },
      //     {
      //       id: 'cmaa6102',
      //       code: 'CMAA 6102',
      //       name: 'Topics in Computational Media and Art II',
      //       note: '(Co-taught)',
      //       terms: ['Spring 2025'],
      //     },
      //     {
      //       id: 'infh6780',
      //       code: 'INFH 6780',
      //       name: 'Information Hub Student Career Development',
      //       note: '(Co-taught)',
      //       terms: ['Spring 2025', 'Spring 2024'],
      //     },
      //   ],
      // }
    ],
  };
